var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-container"},[(this.icon === 'bars')?_c('span',{staticClass:"icon-bars",on:{"click":_vm.emitClick}},[_c('span'),_c('span'),_c('span')]):(this.icon === 'close')?_c('span',{staticClass:"icon-close-container",on:{"click":_vm.emitClick}},[_c('span',{staticClass:"icon-close"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }